module.exports = __webpack_public_path__ + "img/KSC02628.2ed6f30b.jpg";